import type {Features} from '@/types/features.types';

export const myparcel_italie: Features = {
  carrierContracts: {
    spring: false,
    dhlFreight: false,
  },
  debug: {
    websockets: false,
  },
  events: {
    sknj: {
      endOfYear: false,
    },
  },
  errors: false,
  portal: {
    events: false,
  },
  page: {
    addresses: {
      import: true,
    },
    collectTrip: false,
    dashboard: true,
    orders: {
      v1vue: false,
      mobile: false,
    },
    prices: {
      scale: {
        dhl: false,
        dpd: false,
        postnl: false,
      },
    },
    settings: {
      shop: {
        emails: true,
        general: false,
        trackTrace: false,
      },
    },
    shipments: {
      overview: false,
      import: false,
      createReturn: false,
      createPallet: false,
    },
    users: false,
  },
  rules: {
    veeValidate: false,
  },
  settings: {
    accountSettingsLegacy: false,
  },
  trackAndTraceModal: false,
} as const;
